import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';

const primary = '#7B6B8D';

export default function Page404() {
  const navigate = useNavigate();

  return (
    <>
    <SEO title="Page Not Found - Couplendar" />
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: primary,
        textAlign: 'center',
        padding: 3,
      }}
    >
      <HeartBrokenIcon sx={{ fontSize: 120, color: 'white', mb: 2, opacity: 0.9 }} />

      <Typography variant="h1" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
        404
      </Typography>

      <Typography variant="h4" sx={{ color: 'white', mb: 1, fontWeight: 300 }}>
        Oops! This page took a day off
      </Typography>

      <Typography variant="body1" sx={{ color: 'white', mb: 4, opacity: 0.9, maxWidth: 500 }}>
        Looks like this URL didn't pull its weight in the relationship.
        Let's get you back to somewhere that actually exists!
      </Typography>

      <Button
        variant="contained"
        size="large"
        onClick={() => navigate('/')}
        sx={{
          backgroundColor: 'white',
          color: primary,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
          },
          fontWeight: 'bold',
          px: 4,
          py: 1.5,
        }}
      >
        Take Me Home
      </Button>
    </Box>
    </>
  );
}